import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * Route refs for the bcm pages, in their own module so a page can link to
 * another without importing the plugin definition that lazy-loads it.
 */

/**
 * /processes - the support matrix.
 *
 * A page only reaches the sidebar if it carries a route ref: AppNav builds the
 * nav from the app's route nodes and drops any whose `core.routing.ref` is
 * absent, however complete its title and icon are. Without this the page is
 * still routable at /processes - just unreachable except by typing the URL.
 */
export const processesRouteRef = createRouteRef();

/**
 * /processes/:name/edit - the flow editor scratchpad.
 *
 * Parameterised, which is also what keeps it OUT of the sidebar: a nav item
 * carries a `RouteRef<undefined>`, so a ref with params is routable and
 * linkable but never offered as a destination of its own. Same reason
 * /catalog/:namespace/:kind/:name does not appear there.
 */
export const processEditorRouteRef = createRouteRef({ params: ['name'] });
